var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditKe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9844 2.96875C11.5703 2.38281 12.5312 2.38281 13.1172 2.96875L14.0312 3.88281C14.6172 4.46875 14.6172 5.42969 14.0312 6.01562L12.9062 7.14062L9.85938 4.09375L10.9844 2.96875ZM12.3672 7.67969L6.90625 13.1406C6.67188 13.375 6.36719 13.5625 6.03906 13.6562L3.20312 14.4766C3.01562 14.5469 2.80469 14.5 2.66406 14.3359C2.5 14.1953 2.45312 13.9844 2.5 13.7969L3.34375 10.9609C3.4375 10.6328 3.625 10.3281 3.85938 10.0938L9.32031 4.63281L12.3672 7.67969Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditKe);
export default __webpack_public_path__ + "static/media/IconEdit_KE.ae6674cf553e9924c90ac84652e77b37.svg";
export { ForwardRef as ReactComponent };